<template>
    <span>
        <!-- Button -->
        <button
            class='my-button'
            v-if="inputType==='button'"
            @click.stop="handleOnChange"
            :class="computedClassNames"
        >
            <span v-if="icon" class='my-button--icon'>{{ icon }}</span>
            <span class='my-button--value'>{{ value || 'Submit' }}</span>
        </button>
        <!-- Checkbox -->
        <div
            class='my-checkbox'
            v-else-if="inputType==='checkbox'"
            :class="{checked: getValue === true}"
            @click.stop="handleOnChange"
        >
            <label />
            <input 
                :checked="getValue"
                type='checkbox'
            />
        </div>
        <!-- Select -->
        <div v-else-if="inputType==='select'">
            <select 
                class='form-field'
                @click.stop
                @change="handleOnChange"
            >
                <option
                    disabled
                    :selected="value === null"
                >
                    Select category
                </option>
                <option
                    v-for="o in options" :key="o.v"
                    :value="o.v"
                    :selected="getValue === o.v"
                >
                    {{ o.d || o.v }}
                </option>
            </select>
        </div>
        <div v-else-if="inputType === 'textArea'">
            <textarea
                class='form-field'
                :value="getValue"
                @click.stop
                @input="handleOnChange"
            />
        </div>
        <!-- Text -->
        <div v-else>
            <input
                @click.stop
                :type="type || 'text'"
                class='form-field'
                :value="getValue"
                @input="handleOnChange"
            >
        </div>
    </span>
</template>

<script>
export default {
    name: 'MyInputs',
    props: ['type', 'value', 'values', 'name', 'handleClick', 'icon', 'options', 'handleChange'],
    methods: {
        handleOnChange (e) {
            this.handleClick && this.handleClick()
            this.handleChange && this.handleChange(this.name, e.target.value)
        },
    },
    computed: {
        inputType () {
            return this.type && this.type.split('_')[0]
        },
        computedClassNames () {
            const classNames = this.type.split('_').reduce((prev, curr, index) => {
                if (index === 0) return prev
                prev[curr] = curr
                return prev
            }, {})
            if (this.inputType === 'button' && this.icon) {
                classNames['my-button--with-icon'] = true
            }
            return classNames
        },
        getValue () {
            if (this.values && this.name && !!this.values[this.name]) {
                return this.values[this.name]
            }
            return this.value
        }
    }
}
</script>

<style lang='scss' scoped>

// BUTTON
$border-radius: 5px;
.my-button {
    $base-padding-ends: 15px;
    $base-padding-top: 10px;
    padding: 0;
    display: flex;
    border-radius: $border-radius;
    justify-content: space-between;
    & span {
        padding: $base-padding-top $base-padding-ends;
        transition: padding .1s;
    }
    & .my-button--icon {
        padding-left: calc(#{$base-padding-ends} + 3px);
        padding-right: calc(#{$base-padding-ends} + 3px);
        background-color: rgba(0,0,0,.2);
        border-radius: $border-radius 0 0 $border-radius;
    }
    
    &.my-button--with-icon:hover {
        .my-button--value {
            padding-left: calc(#{$base-padding-ends} + 3px);
            padding-right: calc(#{$base-padding-ends} - 3px);
        }
    }
}

// CHECKBOX
.my-checkbox {
    $itemHeight: 24px;
    position: relative;
    width: calc(#{$itemHeight} * 2.1);
    height: $itemHeight;
    background-color: rgb(168, 168, 168);
    border-radius: calc(#{$itemHeight} / 2.1);
    cursor: pointer;
    & > label {
        width: calc(#{$itemHeight} - 4px);
        height: calc(#{$itemHeight} - 4px);
        border-radius: 50%;
        position: absolute;
        left: 4px;
        top: 2px;
        background-color: rgb(230, 230, 230);
        box-shadow: 0 0 2px black;
        cursor: pointer;
        transition: all .3s;
    }
    input {
        display: none;
    }
    &.checked {
        background-color: rgb(113, 179, 201);
        & > label {
            background-color: rgb(205, 232, 236);
            left: calc(#{$itemHeight} * 2.1 - #{$itemHeight});
        }
    }
}

select {
    padding: 9px 13px;
    cursor: pointer;
}
</style>